import React, { useEffect, useState, useContext } from 'react'
import PageHeader from '../../pageheader/PageHeader'
import Input from '../../material/input/Input';
import AutoComplete from '../../material/autoComplete/AutoComplete'
import Select from '../../material/select/Select';
import { HashLoader } from 'react-spinners';
import * as publicApi from '../../../service/publicApi'
import * as userApi from '../../../service/userApi'
import * as regex from '../../../service/regex';
import moment from 'moment/moment'
import 'moment/locale/th'
import MenuHospital from '../navHospital/MenuHospital'
import Footer from "../../footer/Footer";

import styles from './ManageInfoHospital.module.css'

import { CurrentUserContext } from '../../../App';
import HeadBar from '../../public/headBar/HeadBar';
// import Breadcrumb from '../../breadcrumb/breadcrumb';
import CheckBoxV3 from '../../material/checkboxV3/CheckBoxV3';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import Datepicker from '../../material/datepicker/Datepicker';
import Breadcrumb from '../../public/breacrumb/breadcrumb';

function ManageInfoHospital({ role }) {

    const {
        setIsMessage
    } = useContext(CurrentUserContext);

    const [loading, setLoading] = useState(true)
    
    const [getImgDefault, setGetImgDefault] = useState(null)
    const [actionState, setActionState] = useState('') //เอ่ไว้สั่งให้ api get data หลังบันทึก
    const [showImageList, setShowImageList] = useState([]);
    const [pname, setPname] = useState('')
    const [pid, setPid] = useState('')
    const [fname, setFname] = useState('')
    const [lname, setLname] = useState('')
    const [lisenceNumber, setLisenceNumber] = useState('')
    const [hospitalName, setHospitalName] = useState('')
    const [address, setAddress] = useState('')
    const [postCode, setPostCode] = useState('')
    const [gender, setGender] = useState('')
    const [birthday, setBirthday] = useState('')
    const [hospitalList, setHospitalList] = useState('')
    const [hospitalId, setHospitalId] = useState('')

    const [provinceId, setProvinceId] = useState('')
    const [districtId, setDistrictId] = useState('')
    const [subDistrictId, setSubDistrictId] = useState('')

    const [provinceList, setProvinceList] = useState([])
    const [districtList, setDistrictList] = useState([])
    const [subDistrictList, setSubDistrictList] = useState([])
    const [disablePname, setDisablePname] = useState(true);
    const [disableFname, setDisableFname] = useState(true);
    const [disableLname, setDisableLname] = useState(true);
    const [disablePid, setDisablePid] = useState(true);

    const [road, setRoad] = useState(null)
    const [building, setBuilding] = useState(null)
    const [moo, setMoo] = useState('')
    const [email, setEmail] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')

    // const [showCard1, setShowCard1] = useState(false)
    const [personalInformation, setPersonalInformation] = useState(false)
    
    // const [showCard2, setShowCard2] = useState(false)
    const [consentForm, setConsentForm] = useState(false)
    const [permissionEmail, setPermissionEmail] = useState(false);

    const user = JSON.parse(localStorage.getItem('user'))

    //if(user['auth']['role'][0] === "HOSPITAL_PERSONNEL"){
        // setDisablePname(true)
        // setDisableFname(true)
        // setDisableLname(true)
        // setDisablePid(true)
    //}

    const pathItems = [
      { name: "หน้าหลัก", url: `/` },
      { name: "จัดการข้อมูลส่วนตัว", url: `${role ?? ""}/manageinfo` },
    ];
    let genderList = [
      {
        key: 'male',
        value: 'ชาย'
      },
      {
        key: 'female',
        value: 'หญิง'
      }
    ];
    let pnameList = [
      {
        key: 'นาย',
        value: 'นาย'
      },
      {
        key: 'นาง',
        value: 'นาง'
      },
      {
        key: 'นางสาว',
        value: 'นางสาว'
      }
    ];

    useEffect(() => {
        getDataUser()

    }, [])

    useEffect(() => {
        getProvinceList()
    }, [])

    // console.log(hospitalList)
    const getDataUser = async () => {
        setLoading(true)
        let res = await userApi.data()
        // console.log(res)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setPname(res['data']['user_data']['pname'])
                setFname(res['data']['user_data']['fname'])
                setLname(res['data']['user_data']['lname'])
                setPid(res['data']['user_data']['pid'])
                setGender(res['data']['user_data']['gender'])
                setBirthday(res['data']['user_data']['birthday'])
                // setBirthday(moment(res['data']['user_data']['birthday']).add(543, 'years').format('DD MMMM YYYY'))
                setAddress(res['data']['user_data']['current_address']['address'])
                setMoo(res['data']['user_data']['current_address']['village_number'])
                setBuilding(res['data']['user_data']['current_address']['building'])
                setPostCode(res['data']['user_data']['current_address']['post_code'])
                setProvinceId(res['data']['user_data']['current_address']['province_id'])
                getDistrictList(res['data']['user_data']['current_address']['province_id'])
                setDistrictId(res['data']['user_data']['current_address']['district_id'])
                getSubDistrictList(res['data']['user_data']['current_address']['district_id'])
                setSubDistrictId(res['data']['user_data']['current_address']['sub_district_id'])
                setEmail(res['data']['user_data']['email'])
                setPhoneNumber(res['data']['user_data']['phone_number'])
                // setHospitalId(res['data']['user_data']['hospital']['hospital_id'])
                setHospitalId(res['data']['user_data']['hospital']['hospital_name']) //เอามาแค่โชว์ ถ้าแก้ไข ได้ให้ใช้ hospital_id แล้วเปิด function autocomplete
                setLisenceNumber(res['data']['user_data']['license_number'])

                setPersonalInformation(res['data']['user_data']['permission']['policy_personal_information'])
                setConsentForm(res['data']['user_data']['permission']['consent_form'])
                setPermissionEmail(res['data']['user_data']['permission']['access_to_email'])

                localStorage.setItem('user', JSON.stringify(res['data']['user_data']))

                setGetImgDefault(res['data']['user_data']?.['profile_image'])

            } else {
                setIsMessage({ type: 'warning', data: res['data']['message_th'] || res['data']['message']})
            }
        } else {
            setIsMessage({ type: 'error', data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่"})
        }
    }

    const updateProfileData = async (phone_number, email, current_address, permission) => {
        let res = ''
        setLoading(true)
        res = await userApi.updateProfileData(phone_number, email, current_address, permission)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setIsMessage({ type: 'success', data: res['data']['message_th'] || res['data']['message']})
            } else {
                setIsMessage({ type: 'warning', data: res['data']['message_th'] || res['data']['message']})
            }
        } else {
            setIsMessage({ type: 'error', data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่"})
        }
    }

    const updateProfileImage = async (targetfiles) => {
        let formData = new FormData;
        formData.append("image", targetfiles[0])
        let res = ''
        setLoading(true)
        res = await userApi.updateProfileImage(formData)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setIsMessage({ type: 'success', data: res['data']['message_th'] || res['data']['message']})
                getDataUser()
            }
            else {
                setIsMessage({ type: 'warning', data: res['data']['message_th'] || res['data']['message']})
            }
        } else {
            setIsMessage({ type: 'error', data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่"})
        }
    }

    const getProvinceList = async () => {
        setLoading(true)
        let res = await publicApi.getProvinceList()
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setProvinceList(res['data']['province_list'].map(item => {
                    return {
                        key: item['province_id'],
                        value: item['province_name']
                    }
                }))
            } else {
                setIsMessage({ type: 'warning', data: res['data']['message_th'] || res['data']['message']})
            }
        } else {
            setIsMessage({ type: 'error', data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่"})
        }
    }

    const getDistrictList = async (id) => {
        setLoading(true)
        let res = await publicApi.getDistrictList(id)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setDistrictList(res['data']['district_list'].map(item => {
                    return {
                        key: item['district_id'],
                        value: item['district_name']
                    }
                }))
            } else {
                setIsMessage({ type: 'warning', data: res['data']['message_th'] || res['data']['message']})
            }
        } else {
            setIsMessage({ type: 'error', data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่"})
        }
    }

    const getSubDistrictList = async (id) => {
        setLoading(true)
        let res = await publicApi.getSubDistrictList(id)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                setSubDistrictList(res['data']['sub_district_list'].map(item => {
                    return {
                        key: item['sub_district_id'],
                        value: item['sub_district_name']
                    }
                }))
            } else {
                setIsMessage({ type: 'warning', data: res['data']['message_th'] || res['data']['message']})
            }
        } else {
            setIsMessage({ type: 'error', data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่"})
        }
    }

    const getHospitalList = async () => {
        setLoading(true)
        let res = await publicApi.getHospitalList()
        setLoading(false)

        if (res) {
            if (res['data']['code'] === 200) {
                setHospitalList(res['data']['hospital_list'].map(item => {
                    return {
                        id: item['hospital_id'],
                        name: item['hospital_name']
                    }
                }))
            } else {
                setIsMessage({ type: 'warning', data: res['data']['message_th'] || res['data']['message']})
            }
        } else {
            setIsMessage({ type: 'error', data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่"})
        }
    }

    const onSelectFile = (e) => {
        if (e !== '') {
            // console.log(e.target.files)
            const uploadFiles = e.target.files
            createUrlBlobFile(uploadFiles)
            updateProfileImage(uploadFiles)
        }
    }

    const createUrlBlobFile = (uploadFiles) => {
        const uploadFilesImageList = Array.from(uploadFiles)

        const imageData = uploadFilesImageList.map((file) => {
            return {
                'name': file['name'],
                'url': URL.createObjectURL(file)
            }
        })
        setShowImageList(imageData)
    }

    const submitButtonClick = () => {
        if (!pname) {
            setIsMessage({ type: 'warning', data: 'กรุณาเลือกคำนำหน้า'})
            return
        }
        if (hospitalId == '') {
            setIsMessage({ type: 'warning', data:'กรุณากรอกโรงพยาบาลต้นสังกัด'})
            return
        }
        if (!address) {
            setIsMessage({ type: 'warning', data:'กรุณากรอกที่อยู่'})
            return
        }
        if (!moo) {
            setIsMessage({ type: 'warning', data:'กรุณากรอกหมู่'})
            return
        }
        if (!postCode) {
            setIsMessage({ type: 'warning', data:'กรุณากรอกรหัสไปรษณีย์'})
            return
        }
        if (!provinceId) {
            setIsMessage({ type: 'warning', data:'กรุณาเลือกจังหวัด'})
            return
        }
        if (!districtId) {
            setIsMessage({ type: 'warning', data:'กรุณาเลือกอำเภอ'})
            return
        }
        if (!subDistrictId) {
            setIsMessage({ type: 'warning', data: 'กรุณาเลือกตำบล'})
            return
        }
        if (!phoneNumber) {
            setIsMessage({ type: 'warning', data: 'กรุณากรอกเบอร์โทร'})
            return
        }
        if (!email) {
            setIsMessage({ type: 'warning', data: 'กรุณากรอก Email'})
            return
        }
        if (!consentForm || !personalInformation) {
            setIsMessage({ type: 'warning', data: 'กรุณา ยินยอมให้เข้าถึงข้อมูล'})
            return
        } else {
          let current_address = {
            address: address,
            building: building,
            village_number: moo,
            alley: "-",
            road: road ?? "-",
            sub_district_id: subDistrictId,
            istrict_id: districtId,
            province_id: provinceId,
            post_code: postCode,
          }
          let permission = {
            access_data_every_time: false,
            access_data_some_time: false,
            consent_form: consentForm,
            policy_personal_information: personalInformation,
            access_to_email: permissionEmail,
          }
          updateProfileData(phoneNumber, email, current_address, permission)
        }

    }

    const pnameOption = [
        {
            key: 'แพทย์หญิง',
            value: 'แพทย์หญิง'
        },
        {
            key: 'นายแพทย์',
            value: 'นายแพทย์'
        }
    ]

    return (
      <div className="global-page">
          {/* <HeadBar /> */}
          <Breadcrumb pathItems={pathItems}/>
          <header className="flex flex-col gap-2 items-center w-full pb-5 mt-[50px]">
              <h1 className="md:text-2xl flex text-3xl font-bold">จัดการข้อมูลส่วนตัว</h1>
              <p className="sm:text-lg flex text-xl font-bold">กรุณากรอกข้อมูลให้ครบถ้วน</p>
              <p className="sm:text-sm sm:font-normal flex text-lg font-bold">เพิ่มข้อมูลที่อยู่และตั้งค่าบัญชีเพื่อเข้าใช้งานในครั้งถัดไป</p>
          </header>
          <div className="2sm:flex-col flex flex-row gap-6 w-full">
              <div className="2sm:w-full flex flex-col gap-2 items-center w-[20%] max-h-[380px] text-nowrap">
                  <div className='overflow-hidden aspect-square rounded-md'>
                      {showImageList.length > 0 ? <>
                          {showImageList.map((i, idx) => {
                              return (
                                  <img key={idx} src={i['url']} alt="รูปโปรไฟล์" />
                              )
                          })}
                      </> : <>
                          {getImgDefault ?
                              <>
                                  <img src={getImgDefault} alt="" />
                              </> : <img className='aspect-square object-cover' src={require('../../../asset/image/image-user.svg').default} alt="" />
                          }
                      </>
                      }
                  </div>
                  <section>
                      <label className="lg:text-xs flex flex-row justify-center items-center gap-2 w-full px-6 py-2 rounded-md text-white text-base bg-[#4F9C9D] cursor-pointer">
                          <FontAwesomeIcon icon={faArrowDown}/>
                          <span>อัปโหลดไฟล์</span>
                          <input
                              type="file"
                              accept="image/png ,image/jpeg"
                              name='images'
                              style={{ display: 'none' }}
                              onChange={(e) => { onSelectFile(e) }} />
                      </label>
                  </section>
                  <div className="lg:text-xs flex flex-col gap-1 justify-center items-center w-full text-base">
                      <span>อัปโหลดไฟล์</span>
                      <span>สกุล jpg, png</span>
                      <span>ขนาดไฟล์ไม่เกิน 10 MB</span>
                  </div>
              </div>
          <div className="2sm:w-full flex flex-col gap-4 w-[70%] h-full">
              <div className="flex flex-col gap-1 py-2 w-full">
                  <span className="lg:text-base text-xl font-bold">ข้อมูลส่วนตัว</span>
                      <div className="sm:flex sm:flex-col grid grid-flow-dense grid-cols-2 gap-5 justify-between w-full pb-2">
                      <div className="w-full">
                          <Select label="เลือกคำนำหน้า" disabled={disablePname} value={pname} setValue={setPname} list={pnameList} placeholder="เลือกคำนำหน้า"></Select>
                      </div>
                      <div className="w-full"></div>
                      <div className="w-full">
                          <Input disabled={disableFname} label="ชื่อ" placeholder="ชื่อ" value={fname} setValue={setFname}></Input>
                      </div>
                      <div className="w-full">
                          <Input disabled={disableLname} label="นามสกุล" placeholder="นามสกุล" value={lname} setValue={setLname}></Input>
                      </div>
                      <div className="w-full">
                          <Input regex={regex.pid()} label="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)"  disabled={disablePid} placeholder="เลขบัตรประจำตัวประชาชน (กรอกตัวเลขไม่ต้องใส่ขีด)" value={pid} setValue={setPid}></Input>
                      </div>
                      {/* <div className="w-full">
                          <Select placeholder="เพศ" value={gender} setValue={setGender} list={genderList}></Select>
                      </div> */}
                      {/* <div className="w-full">
                          <Datepicker label="วันเกิด" value={birthday} setValue={setBirthday}></Datepicker>
                      </div> */}
                      <div className="w-full">
                          <Input disabled placeholder="โรงพยาบาลต้นสังกัด" label="โรงพยาบาลต้นสังกัด" value={hospitalId} setValue={setHospitalId}></Input>
                      </div>
                  </div>
              </div>
              <div className="flex flex-col gap-2 py-2 w-full">
                  <span className="lg:text-base text-xl font-bold">{ user['auth']['role'][0] === 'HOSPITAL' ? "ที่อยู่โรงพยาบาล":"ที่อยู่ปัจจุบัน"}</span>
                  <div className="sm:flex sm:flex-col grid grid-flow-dense grid-cols-2 gap-5 justify-between w-full pb-2">
                      <div className="w-full">
                          <Input placeholder="บ้านเลขที่" label="บ้านเลขที่" value={address} setValue={setAddress}></Input>
                      </div>
                      <div className="w-full">
                          <Input placeholder="อาคาร/ตึก/ชั้น" label="อาคาร/ตึก/ชั้น" value={building} setValue={setBuilding}></Input>
                      </div>
                      <div className="w-full">
                          <Input placeholder="หมู่" label="หมู่" value={moo} setValue={setMoo}></Input>
                      </div>
                              {/* <div className="w-full">
                                  <Input placeholder="ตรอก/ซอย" value={alley} setValue={setAlley}></Input>
                              </div>
                              <div className="w-full">
                                  <Input placeholder="ถนน" value={road} setValue={setRoad}></Input>
                              </div> */}
                      <div className="w-full">
                          <Select label="จังหวัด" placeholder="จังหวัด" value={provinceId} setValue={(e) => {
                              setProvinceId(e)
                              setDistrictId('')
                              setDistrictList([])
                              setSubDistrictId('')
                              setSubDistrictList([])
                              getDistrictList(e)
                          }} list={provinceList}></Select>  
                      </div>
                      <div className="w-full">
                          <Select label="อำเภอ" placeholder="อำเภอ" value={districtId} setValue={(e) => {
                              setDistrictId(e)
                              setSubDistrictId('') 
                              setSubDistrictList([])
                              getSubDistrictList(e)
                          }} list={districtList}></Select>
                      </div>
                      <div className="w-full">
                          <Select label="ตำบล" placeholder="ตำบล" value={subDistrictId} setValue={setSubDistrictId} list={subDistrictList}></Select>
                      </div>
                      <div className="w-full">
                          <Input placeholder="รหัสไปรษณีย์" label="รหัสไปรษณีย์" value={postCode} setValue={setPostCode}></Input>
                      </div>
                  </div>
              </div>
              <div className="flex flex-col gap-1 py-2 w-full">
                  <span className="lg:text-base text-xl font-bold">ข้อมูลติดต่อ</span>
                      <div className="sm:flex sm:flex-col grid grid-flow-dense grid-cols-2 gap-5 justify-between w-full pb-2">
                          <div className="w-full">
                              <Input placeholder="หมายเลขโทรศัพท์" label="หมายเลขโทรศัพท์" value={phoneNumber} setValue={setPhoneNumber}></Input>
                          </div>
                          <div className="w-full">
                              <Input placeholder="อีเมล" label="อีเมล" value={email} setValue={setEmail}></Input>
                          </div>
                      </div>
                  </div>
                  <div className="mt-[1rem]">
                        <span className="lg:text-base text-xl font-bold">
                                ยินยอมการเข้าถึงแจ้งเตือนผ่าน Email
                            </span>
                    <CheckBoxV3
                    id="checkbox3"
                    value={permissionEmail}
                    setValue={setPermissionEmail}
                    label='ยินยอมการเข้าสู่ระบบผ่าน Email'
                    />
                <span className="lg:text-base text-xl font-bold mt-[1rem]">
                    ยินยอมอนุญาตการเปิดเผยและเข้าถึงข้อมูล
                </span>
              </div>
                  <CheckBoxV3 id="checkbox1" value={personalInformation} setValue={setPersonalInformation} label='การยินยอมให้แลกเปลี่ยนข้อมูลกับระเบียนสุขภาพส่วนบุคคลที่เชื่อมต่อกับระบบ "ผูกพันธ์ุ"' />
                  <CheckBoxV3 id="checkbox2" value={consentForm} setValue={setConsentForm} label="ยินยอมในการให้ข้อมูลการตรวจทางพันธุกรรมที่มาจากระบบสารสนเทศของโรงพยาบาล การตรวจจากห้องปฏิบัติการกรมวิทยาศาสตร์การแพทย์ และระบบอื่น ๆ สามารถใช้แลกเปลี่ยนและจัดเก็บในระบผูกพันธุ์ได้" />
              </div>
          </div>
          <div className='flex justify-center mt-12 w-full'>
              <button onClick={submitButtonClick} className='h-12 w-64 bg-blue-500 text-white rounded-md shadow-md cursor-pointer md:w-[140px] md:text-[12px] md:h-8'><p>บันทึก</p></button>
          </div>
    </div>
  )
}
export default ManageInfoHospital